import React from 'react';
import ReactSelect from '../ReactSelect';

export type AssemblyProtectionType =
  (typeof protectionTypeOptions)[number]['value'];

const protectionTypeOptions = [
  {
    value: 'SERVICE',
    label: 'Service',
  },
  {
    value: 'INTERNAL',
    label: 'Internal',
  },
] as const;

export const AssemblyProtectionTypePicker = ({
  value,
  isClearable,
  onChange,
  placeholder = 'protection',
}: {
  value?: AssemblyProtectionType;
  isClearable?: boolean;
  onChange: (value?: AssemblyProtectionType) => void;
  placeholder?: string;
}) => (
  <ReactSelect
    placeholder={placeholder}
    isClearable={isClearable}
    value={protectionTypeOptions.find((option) => value === option.value)}
    styles={{
      menu: (base) => ({
        ...base,
        minWidth: '150px',
      }),
    }}
    onChange={(value) => {
      onChange(value?.value ?? undefined);
    }}
    options={protectionTypeOptions}
  />
);
